"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EventEmitter = require('events');

var VALUE_CAPTURED_ABI = require('../../abi/ValueCaptured.json');

var ACCOUNT_ERROR = 'Cannot get account';
var INSTANCE_ERROR = 'Cannot create codebase moderator instance';

var ValueCaptured = /*#__PURE__*/function () {
  function ValueCaptured(VALUE_CAPTURED_ADDRESS, web3Instance) {
    var _this = this;

    _classCallCheck(this, ValueCaptured);

    _defineProperty(this, "share", function (blockNumber) {
      return new Promise(function (resolve, reject) {
        _this.web3.eth.getAccounts(function (er, accounts) {
          if (er) return reject(er);
          if (!accounts || accounts.length <= 0 || !_this.web3.utils.isAddress(accounts[0])) return reject(ACCOUNT_ERROR);
          return _this.VALUE_CAPTURED.INSTANCE.methods.share(blockNumber).send({
            from: accounts[0]
          }).on('transactionHash', function (txId) {
            return resolve(txId);
          }).on('error', function (er) {
            return reject(er);
          });
        });
      });
    });

    _defineProperty(this, "watch", function () {
      return new Promise(function (resolve, reject) {
        if (!_this.VALUE_CAPTURED) return reject(INSTANCE_ERROR);

        var watcher = _this.VALUE_CAPTURED.INSTANCE.events.allEvents({
          fromBlock: 'latest'
        }, function (er, event) {
          if (er) return _this.emitter.emit('error', er);
          return _this.emitter.emit('data', event);
        });

        var stopWatching = function stopWatching() {
          watcher.unsubscribe();
          return _this.emitter.removeAllListeners();
        };

        return resolve({
          stopWatching: stopWatching,
          event: _this.emitter
        });
      });
    });

    var Emitter = /*#__PURE__*/function (_EventEmitter) {
      _inherits(Emitter, _EventEmitter);

      var _super = _createSuper(Emitter);

      function Emitter() {
        _classCallCheck(this, Emitter);

        return _super.apply(this, arguments);
      }

      return Emitter;
    }(EventEmitter);

    this.emitter = new Emitter();
    if (!web3Instance) return false;
    this.web3 = web3Instance;
    if (!VALUE_CAPTURED_ABI) return false;
    if (!VALUE_CAPTURED_ADDRESS || !this.web3.utils.isAddress(VALUE_CAPTURED_ADDRESS)) return false;
    var VALUE_CAPTURED_CONTRACT = new this.web3.eth.Contract(VALUE_CAPTURED_ABI, VALUE_CAPTURED_ADDRESS);
    this.VALUE_CAPTURED = {
      ABI: VALUE_CAPTURED_ABI,
      ADDRESS: VALUE_CAPTURED_ADDRESS,
      INSTANCE: VALUE_CAPTURED_CONTRACT
    };
  }
  /**
   * Statics
   */


  _createClass(ValueCaptured, null, [{
    key: "ABI",
    get: function get() {
      return VALUE_CAPTURED_ABI;
    }
    /**
     * Share bounty
     * @param blockNumber - block number
     */

  }]);

  return ValueCaptured;
}();

module.exports = ValueCaptured;